import {FIELD_NAME} from './pcConstAppData';

export const ConnectionStatus = {
  IDLE: 'IDLE',
  CONNECTED: 'CONNECTED',
  RECONNECTING: 'RECONNECTING',
  ERROR: 'ERROR',
  CLOSE: 'CLOSE',
};

export const FileExt = {
  ZIP: 'zip',
  CSV: 'csv',
  PDF: 'pdf',
};

export const Reducers = {
  APP: 'appState',
  LOADING: 'loadingState',
  MODAL: 'modalState',
  TOAST: 'toastState',
  SIGNALR: 'signalRState',
  AUTO_PROFILE: 'autoProfileState',
  DEBUG_STORE: 'debugStore',
  DEVICE_INFO_STORE: 'deviceInfoStore',
  DEVICE_STORE: 'deviceStore',
  LOADING_STORE: 'loadingStore',
  MANUAL_CONTROL_STORE: 'manualControlStore',
  MODAL_STORE: 'modalStore',
  SETUP_STORE: 'setupStore',
  TOAST_STATE: 'toastState',
  UPDATE_SYSTEM_STORE: 'updateSystemStore',
  TIME_ZONE_STORE: 'timeZoneStore',
  SCHEDULER: 'schedulerState',
};

export const DurationUnit = {
  HOURS: 'hours',
  MINUTES: 'minutes',
  SECONDS: 'seconds',
};

export const GenericError = {
  BUSY: 'busy',
};

export const ViewMode = {
  DASHBOARD: 'Dashboard',
};

export const MenuType = {
  Default: 'Default',
  Group: 'Group',
};

export const Orientation = {
  POTRAIT: 'Potrait',
  LANDSCAPE: 'Landscape',
};

export const SignalRHub = {
  DEVICE: 'devicehub',
};

export const SignalRHubState = {
  [SignalRHub.DEVICE]: 'signalrDeviceHub',
};

export const RestAPIMethod = {
  GET: 'GET',
  POST: 'POST',
  PUT: 'PUT',
  DELETE: 'DELETE',
};

export const ResponseCode = {
  SUCCESS: 2000,
  NON_BARCODE_DETECTED: 2160,

  INVALID: 4001,
  DUPLICATED: 4041,
  EXCEED_LIMIT: 4043,

  USER_NOT_FOUND: 5104,
  MAX_BARCODE_REACHED: 5160,
  BARCODE_CONFLICT: 5161,
  TOPOLOGY_NOT_FOUND: 5200,
  INVALID_VERTEX_POSITION: 5203,
  No_Map_and_Topology_Applied: 5205,
};

export const Status = {
  SUCCESS: 'success',
  FAILED: 'failed',
  ERROR: 'Error',
  CONNECTED: 'connected',
  DISCONNECTED: 'disconnected',
};

export const AutoProfileOperationMode = {
  SINGLE_TUBE_CONCENTRATION: 'SINGLE_TUBE_CONCENTRATION',
  TWO_TUBE_CONCENTRATION: 'TWO_TUBE_CONCENTRATION',
  BUFFER_EXCHANGE: 'BUFFER_EXCHANGE',
};

export const AutoProfileOperationModeMethod = {
  [AutoProfileOperationMode.SINGLE_TUBE_CONCENTRATION]: FIELD_NAME.CONCENTRATE,
  [AutoProfileOperationMode.TWO_TUBE_CONCENTRATION]: FIELD_NAME.CONC_TWO_TUBES,
  [AutoProfileOperationMode.BUFFER_EXCHANGE]: FIELD_NAME.BUFFER_EXCHANGE,
};

/**
 * @enum {string}
 */
export const UpdateStateEnum = {
  IDLE: 'IDLE',
  PREPARING: 'PREPARING',
  IN_PROGRESS: 'IN_PROGRESS',
  COMPLETE: 'COMPLETE',
  NO_UPDATE: 'NO_UPDATE',
  FAILED: 'FAILED',
  CONCENTRATING: 'CONCENTRATING',
};

/**
 * @enum {string}
 */
export const UpdateSWStatusType = {
  IDLE: 'IDLE',
  IN_PROGRESS: 'IN_PROGRESS',
  COMPLETE: 'COMPLETE',
  FAILED: 'FAILED',
};

/**
 * @enum {string}
 */
export const DeviceFailureError = {
  VOLUME_SLOW_DEVICE: 'VOLUME_SLOW_DEVICE',
  VOLUME_FAST_DEVICE: 'VOLUME_FAST_DEVICE',
  VOLUME_CHANGES_SIGNIFICANLY: 'VOLUME_CHANGES_SIGNIFICANLY',
  VOLUME_SENSOR_NOT_RESPONDING: 'VOLUME_SENSOR_NOT_RESPONDING',
  VOLUME_SENSOR_TUBE_NOT_AVAILABLE: 'VOLUME_SENSOR_TUBE_NOT_AVAILABLE',
};

/**
 * @enum {string}
 */
export const MembraneTypeEnum = {
  MPES: 'MPES',
  RC: 'RC',
};

export const DurationUnitOfRelativeMode = {
  HOURS: 'Hours',
  MINUTES: 'Minutes',
};

export const ResponseData = {
  NOT_FOUND: 'NotFound',
  NO_USER_FOUND: 'NoUserFound',
  NOT_APPLICABLE: 'NotApplicable',
};
